module.exports = "<div ng-include=\"'/modals/sources/detail.box.html'\"></div>"


//////////////////
// WEBPACK FOOTER
// ./project/modals/sources/partials/detail.clio.html
// module id = 859
// module chunks = 3